/**
 * Clinic branding configuration for report exports.
 * 
 * This configuration is used to inject clinic identity into
 * PDF exports and printed reports. Override via environment
 * variables or replace with API-fetched config in production.
 */

export interface ClinicBrandingConfig {
  clinicName: string;
  logoUrl: string | null;
  address: string;
  phone: string;
  footer: string;
}

const defaultBranding: ClinicBrandingConfig = {
  clinicName: import.meta.env.VITE_CLINIC_NAME || 'Radiology Department',
  logoUrl: import.meta.env.VITE_CLINIC_LOGO_URL || null,
  address: import.meta.env.VITE_CLINIC_ADDRESS || '',
  phone: import.meta.env.VITE_CLINIC_PHONE || '',
  footer: import.meta.env.VITE_CLINIC_FOOTER || 'CONFIDENTIAL — This report is intended for the referring physician only.',
};

export function getClinicBranding(): ClinicBrandingConfig {
  return { ...defaultBranding };
}

export default defaultBranding;
